import { useEffect, useState } from "react";
import type { Route } from "../routes";
import { parseRoute, routeToHash } from "../routes";

/** The current hash route, updated on back/forward and link clicks. */
export const useRoute = (): Route => {
  const [route, setRoute] = useState<Route>(() =>
    parseRoute(window.location.hash)
  );

  useEffect(() => {
    const onHashChange = (): void => setRoute(parseRoute(window.location.hash));
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return route;
};

export const navigate = (route: Route): void => {
  window.location.hash = routeToHash(route);
};
